export const DEBUG = process.env.REACT_APP_DEBUG === "true" ? true : false;
